import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const Label = styled.span`
    padding-bottom: 4px;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${Colors.Black.V50};
`;
